import React from "react";
import "./AdapidAppLockerActivityList.css"; 
import { 
  CheckCircle, 
  XCircle, 
  AlertTriangle, 
  Shield, 
  Clock, 
  Activity 
} from "lucide-react";
import { useTimezone } from "../../../../context/TimezoneContext";
import { formatDateByTimezone } from "../../../../utils/dateFormatter";

const StatusIcon = ({ success }) => {
  const iconProps = { size: 16, strokeWidth: 2 };
  // Mapping behavior_success "True"/"False" to your icons
  if (success === "True") return <CheckCircle {...iconProps} />;
  if (success === "False") return <XCircle {...iconProps} />;
  return <AlertTriangle {...iconProps} />;
};

export const AdapidAppLockerActivityList = ({ events = [] }) => {
  const { timezone } = useTimezone();
  return (
    <div className="adapid-applocker-event-stream">
      {events.map((e) => {
        const statusMap = {
          "Profile created": "success",
          "Legitimate user": "success",
          "Insufficient data": "warning",
          "Suspicious user": "danger"
        };

        const statusClass = statusMap[e.behavioral_status] || "failure";

        return (
          <div 
            key={e.id} 
            className={`adapid-applocker-event-card ${statusClass}`}
            style={{ cursor: 'pointer' }}
          >
            {/* Left Indicator Bar */}
            <div className={`adapid-applocker-event-indicator ${statusClass}`}>
              <StatusIcon success={e.behavior_success} />
            </div>

            <div className="adapid-applocker-event-content">
              {/* Primary Info */}
              <div className="adapid-applocker-event-primary">
                <div className="adapid-applocker-event-title">
                  <span className="adapid-applocker-actor-name">{e.username || "Unknown User"}</span>
                </div>
                
                <div className="adapid-applocker-event-badges">
                  {/* <span className={`status-badge ${statusClass}`}>
                    <StatusIcon success={e.behavior_success} />
                    {e.behavioral_success}
                  </span> */}
                  
                    <span className="adapid-applocker-risk-badge medium">
                      <Shield size={14} strokeWidth={2} />
                      Risk Score: {e.combined_risk_score} 
                    </span>
                </div>
              </div>

              {/* Metadata Grid */}
              <div className="adapid-applocker-event-metadata">
                <div className="adapid-applocker-metadata-item">
                  <Activity size={14} />
                  <span>app: {e.app?.replace(/\.exe$/i, "")}</span>
                </div>
                
                <div className="adapid-applocker-metadata-item">
                  {/* <User size={14} /> */}
                  <span>User Type: {e.user_type}</span>
                </div>
                <div className="adapid-applocker-metadata-item">
                  {/* <User size={14} /> */}
                  <span>Device: {e.device_name || null}</span>
                </div>
                
                <div className="adapid-applocker-metadata-item">
                  <Clock size={14} />
                  <span>{formatDateByTimezone(e.auth_time_iso, timezone, "N/A")}</span>
                </div>
              </div>

              {/* Message / Risk Alerts Section */}
              {e.message && (
                <div className={`adapid-applocker-risk-alerts ${statusClass}`}>
                  <div className={`adapid-applocker-risk-alert ${statusClass}`}>
                    <AlertTriangle size={14} />
                    <span>{e.message}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};